module.exports = __webpack_public_path__ + "img/1980-mobile2.67eb56f2.jpg";